module.exports = __webpack_public_path__ + "static/media/LuisAlexisGodinezFlores.48e5b27e.png";